export enum FaqCategory {
    GENERAL = 'Général',
    ACCOUNT = 'Compte',
    SUBSCRIPTION = 'Abonnement',
    PAYMENT = 'Paiement',
    OTHER = 'Autre',
}

export interface Faq {
    id?: string
    question: string
    answer: string
    category: FaqCategory
    order: number
    isActive: boolean
    createdAt?: string
    updatedAt?: string
}
